var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0C11.8539 0 9.41212 1.03016 7.61177 2.86384C5.81143 4.69753 4.8 7.18455 4.8 9.77778C4.8 12.371 5.81143 14.858 7.61177 16.6917C9.41212 18.5254 11.8539 19.5556 14.4 19.5556C16.9461 19.5556 19.3879 18.5254 21.1882 16.6917C22.9886 14.858 24 12.371 24 9.77778C24 7.18455 22.9886 4.69753 21.1882 2.86384C19.3879 1.03016 16.9461 0 14.4 0ZM3.516 4.66889C1.296 6.52667 0 9.30111 0 12.2222C0 14.8154 1.01143 17.3025 2.81178 19.1362C4.61212 20.9698 7.05392 22 9.6 22C10.368 22 11.124 21.9022 11.856 21.7189C9.744 21.2422 7.8 20.1667 6.204 18.6878C3.864 17.4167 2.4 14.9233 2.4 12.2222C2.4 11.8556 2.436 11.5011 2.484 11.1344C2.436 10.6822 2.4 10.23 2.4 9.77778C2.4 8.01778 2.784 6.27 3.516 4.66889ZM19.308 4.98667L21 6.72222L13.2 14.6667L8.652 10.0344L10.356 8.29889L13.2 11.2078",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.2ccd3527e305b520c0c859beac062cf0.svg";
export { ForwardRef as ReactComponent };